export class MakePaymentMethodDefaultRequestDTO{
      paymentMethodId !: string

      constructor(data: MakePaymentMethodDefaultRequestDTO){
        Object.assign(this, data);
      }
}